// extracted by mini-css-extract-plugin
export var editButton = "detailsEvent-module--edit-button--8145a";
export var evenement = "detailsEvent-module--evenement--0096a";
export var eventContent = "detailsEvent-module--event-content--04767";
export var eventDate = "detailsEvent-module--event-date--e2e65";
export var eventDateFrom = "detailsEvent-module--event-date-from--30603";
export var eventDateTo = "detailsEvent-module--event-date-to--6d796";
export var eventFooter = "detailsEvent-module--event-footer--e503a";
export var eventFooterBack = "detailsEvent-module--event-footer-back--7142c";
export var eventImg = "detailsEvent-module--event-img--cd0e0";
export var eventPlace = "detailsEvent-module--event-place--93345";
export var eventPlaceIcon = "detailsEvent-module--event-place-icon--dbed7";
export var eventPlaceTitle = "detailsEvent-module--event-place-title--ebe4f";
export var eventTaxo = "detailsEvent-module--event-taxo--b36e9";
export var eventTitle = "detailsEvent-module--event-title--66a12";
export var eventsItemRecurrence = "detailsEvent-module--events-item-recurrence--c470f";
export var pageEvent = "detailsEvent-module--page-event--50019";
export var pageEventAdditionalInfos = "detailsEvent-module--page-event-additional-infos--8ffa8";